exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".required-asterisk{color:#ff553d;font-weight:100;font-size:12px}.form-legend-text{color:#999!important;font-style:italic}.legend-bottom-rule{padding-bottom:4px;border-bottom:1px solid #ddd}", ""]);

// exports
